module.exports = function(obj) {
  /*
    * paramChannel
    * targetChannel:zhw_weimi65
    * guid
    * siteid
    * pageid
    * ucid
    * */
  if (obj.paramChannel === obj.targetChannel) {
    console.log('begin ocpc...');
    $('#btnReg').attr('data-click', '{"type":"book"}');
    window.statConf = {'guid': obj.guid, 'siteid': obj.siteid, 'pageid': obj.pageid, 'ucid': obj.ucid}
    let ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src = document.location.protocol + '//' + 'isite.baidu.com/static/stat.js';
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ta, s);
  }
}



// WEBPACK FOOTER //
// ./web/js/mgm/common/bd-ocpc.js